"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _configuration = require("../configuration");
var _ServiceLocator = require("../ServiceLocator");
var _AbstractInteractionService = _interopRequireDefault(require("../../Framework/Services/AbstractInteractionService"));
var _Api = _interopRequireDefault(require("../../Framework/Api"));
var _i18n = require("../../Framework/i18n");
var _Selectors = require("../Reducers/Configurator/Selectors");
var _Constant = require("../Constant");
var _createMessageInterface = require("../Utils/createMessageInterface");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var InteractionService = exports["default"] = /*#__PURE__*/function (_AbstractInteractionS) {
  _inherits(InteractionService, _AbstractInteractionS);
  var _super = _createSuper(InteractionService);
  function InteractionService() {
    _classCallCheck(this, InteractionService);
    return _super.call(this);
  }
  _createClass(InteractionService, [{
    key: "init",
    value: function init() {
      _ServiceLocator.Services.store.observeStore(function (state) {
        return state.i18n.locale;
      }, function (language) {
        _ServiceLocator.Services.interaction.doLanguageSwitch(language);
      });
    }
  }, {
    key: "postMessageToContainer",
    value: function postMessageToContainer(data, options) {
      var conf = _objectSpread({
        targetOrigin: '*'
      }, options);
      var wnd = conf.window || window;
      if (wnd.parent.postMessage !== undefined) {
        var targetOrigin = conf.targetOrigin;
        wnd.parent.postMessage(data, targetOrigin);
      }
    }
  }, {
    key: "saveConfiguration",
    value: function () {
      var _saveConfiguration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var ui, configurator, code;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              ui = _ServiceLocator.Services.ui, configurator = _ServiceLocator.Services.configurator;
              ui.dismissError();
              ui.beginWork('saveConfiguration');
              ui.hide('optionlist');
              ui.show('saveConfiguration');
              _context.prev = 5;
              _context.next = 8;
              return configurator.captureAndSaveConfiguration(_configuration.SaveTypes.USER);
            case 8:
              code = configurator.state.configuration.code;
              this.postMessageToContainer({
                method: _createMessageInterface.METHOD_CONFIGURATION_SAVED,
                code: code
              });
              _context.next = 16;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](5);
              // eslint-disable-next-line no-console
              console.error(_context.t0);
              ui.reportError((0, _i18n.t)('saveConfiguration.error.savingFailed'));
            case 16:
              _context.prev = 16;
              ui.endWork('saveConfiguration');
              return _context.finish(16);
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[5, 12, 16, 19]]);
      }));
      function saveConfiguration() {
        return _saveConfiguration.apply(this, arguments);
      }
      return saveConfiguration;
    }()
  }, {
    key: "shareConfiguration",
    value: function () {
      var _shareConfiguration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var ui, configurator;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              ui = _ServiceLocator.Services.ui, configurator = _ServiceLocator.Services.configurator;
              ui.dismissError();
              ui.beginWork('shareConfiguration');
              ui.hide('optionlist');
              ui.show('shareConfiguration');
              _context2.prev = 5;
              _context2.next = 8;
              return configurator.captureAndSaveConfiguration(_configuration.SaveTypes.SHARE);
            case 8:
              _context2.next = 14;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](5);
              // eslint-disable-next-line no-console
              console.error(_context2.t0);
              ui.reportError((0, _i18n.t)('shareConfiguration.error.savingFailed'));
            case 14:
              _context2.prev = 14;
              ui.endWork('shareConfiguration');
              return _context2.finish(14);
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[5, 10, 14, 17]]);
      }));
      function shareConfiguration() {
        return _shareConfiguration.apply(this, arguments);
      }
      return shareConfiguration;
    }()
  }, {
    key: "mailConfiguration",
    value: function () {
      var _mailConfiguration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var ui, configurator;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              ui = _ServiceLocator.Services.ui, configurator = _ServiceLocator.Services.configurator;
              ui.dismissError();
              ui.beginWork('mailConfiguration');
              ui.hide('optionlist');
              ui.show('mailConfiguration');
              ui.show('globalLoader');
              _context3.prev = 6;
              _context3.next = 9;
              return configurator.captureAndSaveConfiguration(_configuration.SaveTypes.MAIL);
            case 9:
              _context3.next = 15;
              break;
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](6);
              // eslint-disable-next-line no-console
              console.error(_context3.t0);
              ui.reportError((0, _i18n.t)('mailConfiguration.error.savingFailed'));
            case 15:
              _context3.prev = 15;
              ui.hide('globalLoader');
              ui.endWork('mailConfiguration');
              return _context3.finish(15);
            case 19:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[6, 11, 15, 19]]);
      }));
      function mailConfiguration() {
        return _mailConfiguration.apply(this, arguments);
      }
      return mailConfiguration;
    }()
  }, {
    key: "printConfiguration",
    value: function () {
      var _printConfiguration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var ui, configurator;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              ui = _ServiceLocator.Services.ui, configurator = _ServiceLocator.Services.configurator;
              ui.dismissError();
              ui.beginWork('printConfiguration');
              ui.hide('optionlist');
              ui.show('printConfiguration');
              ui.show('globalLoader');
              _context4.prev = 6;
              _context4.next = 9;
              return configurator.captureAndSaveConfiguration(_configuration.SaveTypes.PRINT);
            case 9:
              _context4.next = 15;
              break;
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](6);
              // eslint-disable-next-line no-console
              console.error(_context4.t0);
              ui.reportError((0, _i18n.t)('printConfiguration.error.savingFailed'));
            case 15:
              _context4.prev = 15;
              ui.endWork('printConfiguration');
              ui.hide('globalLoader');
              return _context4.finish(15);
            case 19:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[6, 11, 15, 19]]);
      }));
      function printConfiguration() {
        return _printConfiguration.apply(this, arguments);
      }
      return printConfiguration;
    }()
  }, {
    key: "loadConfiguration",
    value: function loadConfiguration() {
      var clearLoadCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (clearLoadCode) {
        _ServiceLocator.Services.configurator.setLoadCode();
      }
      _ServiceLocator.Services.ui.dismissError();
      _ServiceLocator.Services.ui.show('loadConfiguration');
    }
  }, {
    key: "adminSaveConfiguration",
    value: function () {
      var _adminSaveConfiguration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(saveType) {
        var ui, configurator, configuration;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              ui = _ServiceLocator.Services.ui, configurator = _ServiceLocator.Services.configurator;
              ui.dismissError();
              ui.beginWork('adminSaveConfiguration');
              ui.hide('optionlist');
              _context5.prev = 4;
              configuration = configurator.prepareConfigurationForSave(true);
              _context5.next = 8;
              return configurator.createMediaDataForConfiguration(configuration);
            case 8:
              return _context5.abrupt("return", _ServiceLocator.Services.adminArea.saveConfiguration(configuration, saveType));
            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5["catch"](4);
              // eslint-disable-next-line no-console
              console.error(_context5.t0);
              ui.reportError((0, _i18n.t)('saveConfiguration.error.savingFailed'));
            case 15:
              _context5.prev = 15;
              ui.endWork('adminSaveConfiguration');
              return _context5.finish(15);
            case 18:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[4, 11, 15, 18]]);
      }));
      function adminSaveConfiguration(_x) {
        return _adminSaveConfiguration.apply(this, arguments);
      }
      return adminSaveConfiguration;
    }()
  }, {
    key: "adminGetConfiguration",
    value: function () {
      var _adminGetConfiguration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var ui, configurator, work, configuration;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              ui = _ServiceLocator.Services.ui, configurator = _ServiceLocator.Services.configurator;
              work = ui.beginWork('adminGetConfiguration');
              ui.dismissError();
              ui.hide('optionlist');
              _context6.prev = 4;
              configuration = configurator.prepareConfigurationForSave(true);
              _context6.next = 8;
              return configurator.createMediaDataForConfiguration(configuration);
            case 8:
              return _context6.abrupt("return", configuration);
            case 11:
              _context6.prev = 11;
              _context6.t0 = _context6["catch"](4);
              // eslint-disable-next-line no-console
              console.error(_context6.t0);
              ui.reportError((0, _i18n.t)('saveConfiguration.error.savingFailed'));
            case 15:
              _context6.prev = 15;
              work.done();
              return _context6.finish(15);
            case 18:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[4, 11, 15, 18]]);
      }));
      function adminGetConfiguration() {
        return _adminGetConfiguration.apply(this, arguments);
      }
      return adminGetConfiguration;
    }()
  }, {
    key: "addToCart",
    value: function () {
      var _addToCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var ui, configurator, overwriteConfiguration, extraData, result;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              ui = _ServiceLocator.Services.ui, configurator = _ServiceLocator.Services.configurator;
              ui.dismissError();
              ui.beginWork('addToCart');
              ui.hide('optionlist');
              ui.show('addToCartPopUpLoader');
              _context7.prev = 5;
              overwriteConfiguration = (0, _configuration.getConf)('fromBasket', false);
              extraData = overwriteConfiguration ? {
                code: _ServiceLocator.Services.configurator.state.configuration.code
              } : {};
              _context7.next = 10;
              return configurator.captureAndSaveConfiguration(_configuration.SaveTypes.CART, extraData);
            case 10:
              result = _context7.sent;
              _ServiceLocator.Services.configurator.addToCartCallback(result.data);
              _context7.next = 19;
              break;
            case 14:
              _context7.prev = 14;
              _context7.t0 = _context7["catch"](5);
              // eslint-disable-next-line no-console
              console.error(_context7.t0);
              ui.reportError((0, _i18n.t)('saveConfiguration.error.savingFailed'));
              throw _context7.t0;
            case 19:
              _context7.prev = 19;
              ui.endWork('addToCart');
              ui.hide('addToCartPopUpLoader');
              return _context7.finish(19);
            case 23:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[5, 14, 19, 23]]);
      }));
      function addToCart() {
        return _addToCart.apply(this, arguments);
      }
      return addToCart;
    }()
  }, {
    key: "sendReceiveOfferRequest",
    value: function () {
      var _sendReceiveOfferRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(formData) {
        var configuration, data;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!formData.hasError) {
                _context8.next = 2;
                break;
              }
              return _context8.abrupt("return", false);
            case 2:
              _context8.prev = 2;
              _ServiceLocator.Services.ui.show('addToCartPopUpLoader');
              _context8.next = 6;
              return _ServiceLocator.Services.configurator.captureAndSaveConfiguration(_configuration.SaveTypes.OFFERREQUEST);
            case 6:
              _ServiceLocator.Services.analytics.triggerEvent(_Constant.EventTypes.selected_amounts);
              _context8.next = 13;
              break;
            case 9:
              _context8.prev = 9;
              _context8.t0 = _context8["catch"](2);
              _ServiceLocator.Services.ui.reportError((0, _i18n.t)('receiveOfferForm.sentError'));
              return _context8.abrupt("return", false);
            case 13:
              _context8.prev = 13;
              _ServiceLocator.Services.ui.hide('addToCartPopUpLoader');
              return _context8.finish(13);
            case 16:
              configuration = _ServiceLocator.Services.configurator.state.configuration;
              data = {
                configurationCode: configuration.code,
                emailAddress: formData.email,
                name: formData.name,
                company: formData.company,
                phoneNumber: formData.phonenumber,
                street: formData.street,
                zip: formData.zip,
                city: formData.city,
                country: formData.country
              };
              _context8.prev = 18;
              _context8.next = 21;
              return _Api["default"].request({
                url: 'receiveoffers/request',
                method: 'post',
                data: data
              });
            case 21:
              this.postMessageToContainer({
                method: _createMessageInterface.METHOD_REQUEST_OFFER_FORM_SENT,
                code: configuration.code
              });
              _context8.next = 28;
              break;
            case 24:
              _context8.prev = 24;
              _context8.t1 = _context8["catch"](18);
              _ServiceLocator.Services.ui.reportError((0, _i18n.t)('receiveOfferForm.sentError'));
              return _context8.abrupt("return", false);
            case 28:
              _ServiceLocator.Services.ui.reportError((0, _i18n.t)('receiveOfferForm.sentOk'));
              return _context8.abrupt("return", true);
            case 30:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[2, 9, 13, 16], [18, 24]]);
      }));
      function sendReceiveOfferRequest(_x2) {
        return _sendReceiveOfferRequest.apply(this, arguments);
      }
      return sendReceiveOfferRequest;
    }()
  }, {
    key: "doLanguageSwitch",
    value: function doLanguageSwitch(language) {
      if (_Api["default"].setLanguage(language) === 1) {
        // if newly set, save and load the configuration
        return _ServiceLocator.Services.configurator.saveAndReloadConfiguration(_configuration.SaveTypes.LANGUAGESWITCH);
      }
    }
  }, {
    key: "setChannel",
    value: function setChannel(channel) {
      if (_Api["default"].setChannel(channel) === 1) {
        // if newly set, save and load the configuration
        if ((0, _configuration.getConf)('setChannelReloadOnly')) {
          return _ServiceLocator.Services.configurator.loadInitialConfiguration();
        } else {
          return _ServiceLocator.Services.configurator.saveAndReloadConfiguration(_configuration.SaveTypes.CHANNELSWITCH);
        }
      }
    }
  }, {
    key: "saveWidgetConfiguration",
    value: function () {
      var _saveWidgetConfiguration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var ui, configurator;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              ui = _ServiceLocator.Services.ui, configurator = _ServiceLocator.Services.configurator;
              ui.dismissError();
              ui.beginWork('saveConfiguration');
              _context9.prev = 3;
              _context9.next = 6;
              return configurator.prepareAndSaveConfiguration(_configuration.SaveTypes.WIDGET);
            case 6:
              _context9.next = 12;
              break;
            case 8:
              _context9.prev = 8;
              _context9.t0 = _context9["catch"](3);
              // eslint-disable-next-line no-console
              console.error(_context9.t0);
              ui.reportError((0, _i18n.t)('saveConfiguration.error.savingFailed'));
            case 12:
              _context9.prev = 12;
              ui.endWork('saveConfiguration');
              return _context9.finish(12);
            case 15:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[3, 8, 12, 15]]);
      }));
      function saveWidgetConfiguration() {
        return _saveWidgetConfiguration.apply(this, arguments);
      }
      return saveWidgetConfiguration;
    }()
  }, {
    key: "openConfigurator",
    value: function openConfigurator() {
      var configuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _Selectors.getConfiguration)(_ServiceLocator.Services.configurator.state);
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var conf = _objectSpread(_objectSpread({
        targetOrigin: '*'
      }, (0, _configuration.getConf)('openConfigurator') || {}), options);
      var code = configuration.code;
      var wnd = conf.window || window;
      switch (conf.method) {
        case _configuration.WidgetAfterSaveMethods.PostMessage:
          {
            if (wnd.parent.postMessage !== undefined) {
              var targetOrigin = conf.targetOrigin;
              wnd.parent.postMessage({
                method: 'openConfigurator',
                code: code
              }, targetOrigin);
            }
            break;
          }
        case _configuration.WidgetAfterSaveMethods.OpenNewWindow:
          {
            wnd.open("/code:".concat(code).concat(wnd.location.search));
            break;
          }
      }
    }
  }, {
    key: "createPdfUrl",
    value: function createPdfUrl() {
      var documentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'user';
      var configuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _Selectors.getConfiguration)(_ServiceLocator.Services.configurator.state);
      var queryParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var params = _objectSpread(_objectSpread({}, _Api["default"].getGETParameters()), queryParams);
      var customKeys = Object.keys(queryParams);
      var keys = ['_language', '_client', '_channel', '_display_net_prices', '_share_url'];
      var mergedKeys = keys.concat(customKeys);
      var query = new URLSearchParams(location.search);
      var queryString = Object.keys(params).filter(function (key) {
        return mergedKeys.indexOf(key) !== -1;
      }).map(function (key) {
        return key === '_share_url' ? key + '=' + encodeURIComponent(params[key]) : key + '=' + params[key];
      }).join('&');
      if (query.has('_hide_prices')) {
        queryString = queryString.concat('&_hide_prices=' + query.get('_hide_prices'));
      }
      if (query.has('_cta_element')) {
        queryString = queryString.concat('&_cta_element=' + query.get('_cta_element'));
      }
      return "".concat((0, _configuration.getConf)('network.baseURL', '/'), "configurations/pdf/").concat(documentType, "/").concat(configuration.code, "?").concat(queryString);
    }
  }, {
    key: "printConfigurationAndOpenPdf",
    value: function () {
      var _printConfigurationAndOpenPdf = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.printConfiguration();
            case 2:
              _ServiceLocator.Services.interaction.showPdfDownloadDialog();
            case 3:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function printConfigurationAndOpenPdf() {
        return _printConfigurationAndOpenPdf.apply(this, arguments);
      }
      return printConfigurationAndOpenPdf;
    }()
  }, {
    key: "saveWidgetConfigurationAndOpenPdf",
    value: function () {
      var _saveWidgetConfigurationAndOpenPdf = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.saveWidgetConfiguration();
            case 2:
              window.open(this.createPdfUrl('widget'));
            case 3:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function saveWidgetConfigurationAndOpenPdf() {
        return _saveWidgetConfigurationAndOpenPdf.apply(this, arguments);
      }
      return saveWidgetConfigurationAndOpenPdf;
    }()
  }, {
    key: "saveWidgetConfigurationAndOpenConfigurator",
    value: function () {
      var _saveWidgetConfigurationAndOpenConfigurator = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return this.saveWidgetConfiguration();
            case 2:
              this.openConfigurator();
            case 3:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function saveWidgetConfigurationAndOpenConfigurator() {
        return _saveWidgetConfigurationAndOpenConfigurator.apply(this, arguments);
      }
      return saveWidgetConfigurationAndOpenConfigurator;
    }()
  }, {
    key: "showLoadConfigurationDialog",
    value: function showLoadConfigurationDialog() {
      _ServiceLocator.Services.ui.show('loadConfiguration');
    }
  }, {
    key: "showSendEmailDialog",
    value: function showSendEmailDialog() {
      _ServiceLocator.Services.ui.show('sendEmail');
    }
  }, {
    key: "showPdfDownloadDialog",
    value: function showPdfDownloadDialog() {
      _ServiceLocator.Services.ui.show('pdfDownload');
    }
  }]);
  return InteractionService;
}(_AbstractInteractionService["default"]);